import React from 'react';
import { FadeIn } from './ui/FadeIn';
export function About() {
  return <section id="about" className="py-32 relative z-20 bg-zinc-950" data-id="element-15">
      <div className="max-w-7xl mx-auto px-6" data-id="element-16">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-24 items-start" data-id="element-17">
          {/* Left Column */}
          <div className="lg:col-span-5" data-id="element-18">
            <FadeIn data-id="element-19">
              <span className="text-sm font-medium tracking-widest uppercase text-zinc-500 mb-6 block" data-id="element-20">
                About MUNISVerse
              </span>
              <h2 className="text-4xl md:text-5xl font-display font-medium leading-tight text-white" data-id="element-21">
                Redefining how you experience space.
              </h2>
            </FadeIn>
          </div>

          {/* Right Column */}
          <div className="lg:col-span-7 space-y-8 text-lg md:text-xl text-zinc-400 font-light leading-relaxed" data-id="element-22">
            <FadeIn delay={0.1} data-id="element-23">
              <p data-id="element-24">
                MUNISVerse is a pioneering PropTech platform in Nigeria, built
                to help users understand spaces remotely through interactive
                virtual tours. We bridge the gap between digital discovery and
                physical reality, ensuring that what you see online is exactly
                what you get.
              </p>
            </FadeIn>
            <FadeIn delay={0.2} data-id="element-25">
              <p data-id="element-26">
                By providing true-to-life 360° property tours, we drastically
                reduce unnecessary physical inspections, eliminate the
                frustration of misleading photos, and empower buyers, renters,
                and investors to make confident, informed decisions from
                anywhere in the world.
              </p>
            </FadeIn>
          </div>
        </div>
      </div>
    </section>;
}